<style scoped>

</style>
<template>
  <div>
    <ExpenseGroup :type="4" />
  </div>
</template>
<script route="/mine/expense_group_none_cost">
  import ExpenseGroup from './expense_group'
  export default {
    /* router_info_start */
    router_info: {
      path:'/mine/expense_group_none_cost',
      noChkout: true
    },
    /* router_info_end */

    components: { ExpenseGroup },
    data() {
      return {
        //
      }
    },
    computed: {
      //
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      //
    }
  }
</script>
